import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { lighten } from 'polished';

import { Table } from 'reactstrap';

export const BillExplanation = styled.div`
  width: 90%;
  margin-left: 2%;
  margin-top: 5px;
`;

export const InformationDiv = styled.div`
  width: 90%;
  border-bottom: 1px solid #dee2e6;
  margin-left: 2%;
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  position: relative;
`;

export const FinalDiv = styled.div`
  width: 90%;
  margin-left: 2%;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  position: relative;
`;

export const Total = styled.div`
  display: flex;
  flex-direction: column;
  span {
    color: grey;
  }
`;

export const Paid = styled.div`
  right: 0;
  position: absolute;
  display: flex;
  flex-direction: column;
  span {
    color: grey;
  }
`;

export const Container = styled.div`
  height: 100%;
  top: 0;
  width: 100%;
  margin: 10px;

  justify-content: center;
  display: flex;
  flex-direction: column;
`;

export const CategoriesTable = styled(Table)`
  width: 95%;
  min-width: 400px;
  align-items: center;
  border-collapse: separate;
  border-spacing: 0 20px;
  background: #fff6b3;
  filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.2));
  border-radius: 8px;
  padding: 0 30px;

  thead {
    border-bottom: 30px solid transparent;
    text-align: left;
    tr {
      th:last-child {
        text-align: right;
      }
    }
  }
  tbody {
    td {
      border-bottom: 1px solid #dee2e6;
    }
    td:last-child {
      text-align: right;
    }

    tr:last-child {
      td {
        border-bottom: none;
      }
    }
  }
`;
export const StyledLink = styled(Link)`
  &:hover {
    text-decoration: none;
  }

  margin-right: 10px;
`;

export const Delete = styled.button`
  border: none;
  background: none;

  &:active {
    border: none;
  }

  svg {
    color: ${(props) => props.theme.colors.secondary};
  }
`;

export const Actions = styled.div``;

export const StatusTag = styled.div.attrs((props) => ({
  color: props.color,
  backgroundcolor: lighten(0.33, props.color),
}))`
  color: ${(props) => props.color};
  background-color: ${(props) => props.backgroundcolor};
  font-weight: bold;
  padding: 5px 10px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  &::before {
    content: ' ';
    display: inline-block;
    position: relative;
    margin-right: 5px;
    width: 10px;
    height: 10px;
    background-color: ${(props) => props.color};
    border-radius: 50%;
  }
`;

export const OpenOrders = styled.div`
  width: 100%;
  padding-bottom: 20px;
  padding-top: 10px;
  margin-left: 2%;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const CloseOrders = styled.div`
  width: 100%;
  padding-bottom: 20px;
  padding-top: 10px;
  border-top: 1px solid #dee2e6;
  margin-left: 2%;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const PaymentTable = styled.table`
  width: 100%;
  margin-top: 10px;

  tr {
    font-size: 18px;
    height: 30px;
  }

  tbody {
    top: 0;
  }
`;

export const AddPaymentButton = styled(Link).attrs((props) => ({
  color: props.color,
  backgroundcolor: lighten(0.33, props.color),
}))`
  background-color: ${(props) => props.backgroundcolor};
  font-weight: bold;
  padding: 5px 10px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  border: none;
  width: 60%;
  &:hover {
    text-decoration: none;
  }
  span {
    color: ${(props) => props.color};
  }
`;

export const Print = styled.button`
  height: 30px;
  width: 30px;
  border-radius: 50%;
  align-self: center;
  float: right;
  position: absolute;
  clear: both;
  right: 0;
  margin-right: 10px;
  border: none;
  background: #2ec4b6;

  :hover {
    filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.2));
    border: solid grey 1px;
    border-radius: 50%;
  }
`;

export const DisplayNoneImprimir = styled.div`
  display: none;
`;
